module.exports = __webpack_public_path__ + "img/base_one.32461c84.svg";